(function() {
    'use strict';

a3_cabin_reports.directive('ssr',ssr);

    
    
   /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name ssr
   * @restrict EA
   * @description
   *   Implementation of issues
   *
   *   Initialize the special service template
   * @attr {String} format The name of the format to initialize the ssr.
   * @example
   *   Usage:
   *   <div ssr format="compact"></div>
   * @ngInject
   */    
function ssr($sce,ssrCodes,waterUpliftSupportingAcTypes) {

	
		return {
			restrict: 'EA',
			terminal: true,
            templateUrl: 'views/directives/ssr.tpl.html',
			scope: {
                paxInfo: '=',
                flight: '='
            },
            link: function ($scope, element, attrs) {
                $scope.format = attrs.format;
                $scope.VIP = detailedInfo('VIP');
                $scope.UPGD = detailedInfo('UPGD');
                // Platinum is a new tier, so calculate its summary defensively without changing existing tiers.
                $scope.FQTVPlatinumSummary = getTierSummary('Platinum');
                $scope.FQTVPlatinum = detailedTierInfo('Platinum');
                $scope.FQTVGold = detailedInfo('FQTVGold');
                $scope.FQTVSilver = detailedInfo('FQTVSilver');
                $scope.UMNR = detailedInfo('UMNR');
                $scope.PRM = detailedInfo('WCBD,WCBW,WCHC,WCHR,WCHS,WCLB,WCMP,WCOB')
                $scope.DEAF = detailedInfo('DEAF')
                $scope.BLND = detailedInfo('BLND')
                $scope.DPNA = detailedInfo('DPNA')
                $scope.DEP = detailedInfo('DEPA,DEPU,ESCD')
                $scope.INAD = detailedInfo('INAD')
                $scope.MEDA = detailedInfo('AOXY,MEDA,MEQT,POXY')
                $scope.CBBG = detailedInfo('CBBG')
                $scope.OTH =  detailedInfo('AVIH,BIKE,EMIG,ESAN,EXST,FAMS,GPST,HAJJ,PETC,SVAN,WEAP,XBGS,MAAS')
                $scope.UndeliveredChargeableSeats = detailedInfo('UndeliveredChargeableSeats')

                $scope.showFQTVPlatinum = false;
                $scope.showFQTVGold = false;
                $scope.showFQTVSilver = false;
                $scope.showUMNR = false;
                $scope.showPRM = false;
                $scope.showDEAF = false;
                $scope.showBLND = false;
                $scope.showDPNA = false;
                $scope.showDEP = false;
                $scope.showINAD = false;
                $scope.showMEDA = false;
                $scope.showCBBG = false;
                $scope.showOTH = false;
                $scope.showIrregularites = false;
                $scope.showVIP = false;
                
                
                $scope.hasZones = hasZones;
                $scope.zoneC = getZone('C');
                $scope.zoneY = getZone('Y');  
                
                $scope.waterQuantity =  getWaterQuantity();
                $scope.supportsWaterUpliftAcType = supportsWaterUpliftAcType(); 
                 
                $scope.UMNRDetails = umnrInfo('UMNR');

                function umnrInfo(umnr) {
                    if($scope.paxInfo) {
                        $scope.totalUMNR = [];
                            $scope.paxInfo.Seatmap.forEach(function (row) {
                            row.Columns.forEach(function (column) {
                               if(column.SSR.IsUMNR)
                               $scope.totalUMNR.push(column);
                            });
                        });
                    }                  
                }

                function supportsWaterUpliftAcType(){
                    return waterUpliftSupportingAcTypes.includes($scope.flight.AcType);
                }
                
                function getWaterQuantity(){
                    var totalPax = $scope.flight.BookedC + $scope.flight.BookedY;
                    var startDate = moment($scope.flight.ScheduledDeparture);
                    var endDate = moment($scope.flight.ScheduledArrival);
                    var duration = moment.duration(endDate.diff(startDate)).asHours();
                    var waterQuantity = (0,18 * totalPax * duration)/200;
                    var formattedwaterQuantity = waterQuantity.toString().substring(0,4);
                    return formattedwaterQuantity;
                }
                
                function hasZones(){
                    var retVal = false;
                    if($scope.flight && $scope.flight.Zones && $scope.flight.Zones.length > 0)
                        retVal = true;
                    return retVal;
                }

                function getZone (classService) {
                    var retVal = '';
                    var zone;
                    if($scope.flight && $scope.flight.Zones){
                        // zone = $scope.flight.Zones.find(function (item) {
                        //     return item.Class == classService || item.Class == '';
                        // });

                        for (var i=0; i<$scope.flight.Zones.length; i++) {
                            if($scope.flight.Zones[i].Class == classService || $scope.flight.Zones[i].Class == ''){
                                zone = $scope.flight.Zones[i];
                                break;
                            }
                        }
                    }
                    if(zone)
                        retVal = zone.Title;
                    return retVal;
                }           

                function getTierSummary(tierName) {
                    var emptySummary = { C: 0, Y: 0, Total: 0 };
                    if (!$scope.paxInfo || tierName != 'Platinum') {
                        return emptySummary;
                    }

                    var summaryC = $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryC.FQTVPlatinum;
                    var summaryY = $scope.paxInfo.PassengerSummaryY && $scope.paxInfo.PassengerSummaryY.FQTVPlatinum;

                    if (typeof summaryC === 'number' && typeof summaryY === 'number') {
                        return { C: summaryC, Y: summaryY, Total: summaryC + summaryY };
                    }

                    if (!$scope.paxInfo.Seatmap) {
                        return emptySummary;
                    }

                    var result = { C: 0, Y: 0, Total: 0 };
                    $scope.paxInfo.Seatmap.forEach(function (row) {
                        row.Columns.forEach(function (column) {
                            if (
                                !column.IsEmptySeat &&
                                column.SeatMode == 'Seat' &&
                                column.Fqtv &&
                                column.Fqtv.TierLevel == 'PLTM'
                            ) {
                                if (column.Cabin == 'C') {
                                    result.C++;
                                } else {
                                    result.Y++;
                                }
                            }
                        });
                    });

                    result.Total = result.C + result.Y;
                    return result;
                }

                function detailedTierInfo(tierName) {
                    var tierSummary = getTierSummary(tierName);
                    var htmlPopover = '';

                    if (tierSummary.Total > 0) {
                        htmlPopover = '<div class="row"> <strong class="col-xs-3 col-md-2 col-xs-offset-1 col-md-offset-4">C ' + tierSummary.C + '</strong>';
                        htmlPopover = htmlPopover + ' <strong class="col-xs-3 col-md-2">Y ' + tierSummary.Y + '</strong>';
                        htmlPopover = htmlPopover + '</div>';
                    }

                    return $sce.trustAsHtml(htmlPopover);
                }



                function detailedInfo(properties){
                    var propertiesArray = properties.split(',');
                    var htmlPopover = ''
                    if($scope.paxInfo && $scope.paxInfo.PassengerSummaryC && $scope.paxInfo.PassengerSummaryY){
                        if(propertiesArray.length>1){
                            htmlPopover =   '<div class="row"><div class="col-sm-offset-9  col-xs-offset-8 col-xs-1"><strong>C</strong></div><div class=" col-xs-1"><strong>Y</strong></div><div class=" col-xs-1"><strong>Total</strong></div> </div>';

                            angular.forEach(propertiesArray,function(property){
                                
                             var Total = $scope.paxInfo.PassengerSummaryC[('Total'+property)]  + $scope.paxInfo.PassengerSummaryY[('Total'+property)];
                                if(Total>0){
                                    var code = '';
                                for (var i = 0; i < ssrCodes.length ; i++){
                                    if(ssrCodes[i].code == property){
                                        code = ssrCodes[i].description;
                                    }
                                }
                                htmlPopover = htmlPopover + '<div class="row"> <strong class="col-xs-2">' + property + "</strong>";
                                htmlPopover = htmlPopover + '<span class="col-sm-7 col-xs-6 text-medium">' + code + "</span>";
                                htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryC[property] + "</div>";
                                 htmlPopover = htmlPopover + '<div class="col-xs-1">' + $scope.paxInfo.PassengerSummaryY[property] + "</div>";
                                
                                htmlPopover = htmlPopover + '<div class="col-xs-1">' 
                                    + Total
                                    + "</div></div>";
                                }
                            })
                        }else{
                            angular.forEach(propertiesArray,function(property){
                                var Total = $scope.paxInfo.PassengerSummaryC[('Total'+property)]  + $scope.paxInfo.PassengerSummaryY[('Total'+property)];
                               htmlPopover = '<div class="row"> <strong class="col-xs-3 col-md-2 col-xs-offset-1 col-md-offset-4">C ' + $scope.paxInfo.PassengerSummaryC[property] + '</strong>';
                               htmlPopover = htmlPopover + ' <strong class="col-xs-3 col-md-2">Y ' + $scope.paxInfo.PassengerSummaryY[property] + '</strong>';
                                if(Total){
                                    htmlPopover = htmlPopover + ' <strong class="col-xs-4 col-md-3"> Total ' + Total + '</strong>';
                                 }
                                  htmlPopover = htmlPopover + '</div>';
                            })
                        }
                    }
                    
                    return $sce.trustAsHtml(htmlPopover);
                }
            }
		}
	}



})();
	
